module.exports = __webpack_public_path__ + "img/flag_galicia.f6022c9b.png";